var _pattern, _rect, _circle, _circle2, _path, _path2, _g, _g2, _g3, _g4, _g5, _path3, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skyGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1c3e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2a3d66",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "moonGlow",
    cx: "80%",
    cy: "30%",
    r: "20%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(255,255,255,0.3)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(255,255,255,0)"
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "magicRunes",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1,
    fill: "#9375db",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15 L20 15 M15 10 L15 20",
    stroke: "#9375db",
    strokeWidth: 0.5,
    opacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "url(#skyGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 150,
    r: 100,
    fill: "url(#moonGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 150,
    r: 40,
    fill: "#ffd700",
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 300 L200 200 L400 280 L600 180 L800 280 L800 500 L0 500 Z",
    fill: "#2b1055",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 340 L300 220 L500 300 L700 200 L800 320 L800 500 L0 500 Z",
    fill: "#3f1c78",
    opacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500,200) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L80 0 L80 100 L0 100 Z",
    fill: "#1a1c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 10 L0 10 L0 120 L-20 120 L-20 10 L-10 0 L0 10",
    fill: "#2b1055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 10 L100 10 L100 120 L80 120 L80 10 L90 0 L100 10",
    fill: "#2b1055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 0 L100 0 L90 -10 L80 0 L70 -10 L60 0 L50 -10 L40 0 L30 -10 L20 0 L10 -10 L0 0 L-10 -10 L-20 0",
    fill: "#2b1055"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 20 L-10 20 Z",
    fill: "#4a237f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -10 L15 5 L-5 5 Z",
    fill: "#4a237f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 8,
    r: 5,
    fill: "#2b1055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L20 -10",
    stroke: "#9375db",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: -10,
    r: 8,
    fill: "url(#magicRunes)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,150) scale(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C30 -20 60 -20 90 0 L100 -10 L110 0 L100 10 L90 0 C60 20 30 20 0 0 Z",
    fill: "#2b1055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 0 L150 -20 L140 0 L150 20",
    fill: "none",
    stroke: "#2b1055",
    strokeWidth: 5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 30 L-10 30 Z",
    fill: "#3f1c78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#3f1c78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15 15 L15 15",
    stroke: "#5d2e8c",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L8 25 L-8 25 Z",
    fill: "#3f1c78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#3f1c78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 10 L10 10",
    stroke: "#5d2e8c",
    strokeWidth: 2
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L5 20 L-5 20 Z",
    fill: "#2b1055"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#2b1055"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L6 25 L-6 25 Z",
    fill: "#3f1c78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#3f1c78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 15 L8 15",
    stroke: "#2b1055",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,0) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L5 20 L-5 20 Z",
    fill: "#2b1055"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#2b1055"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 380 L200 280 L400 380 L600 280 L800 380 L800 500 L0 500 Z",
    fill: "#5d2e8c"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150 150 L160 130 L170 150 L160 160 Z",
    fill: "#9375db",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 180 L310 160 L320 180 L310 190 Z",
    fill: "#9375db",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 140 L460 120 L470 140 L460 150 Z",
    fill: "#9375db",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 1,
    fill: "white",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 180,
    r: 1,
    fill: "white",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 140,
    r: 1,
    fill: "white",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 1,
    fill: "white",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 130,
    r: 1,
    fill: "white",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 170,
    r: 1,
    fill: "white",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBackground);
export default __webpack_public_path__ + "static/media/hero-background.6e35bd657b2f02d2984610b0e339ce0b.svg";
export { ForwardRef as ReactComponent };